<template>
  <form v-on="$listeners">
    <p v-if="requiredFields">Bitte füllen Sie alle mit * gekennzeichneten Felder aus.</p>
    <slot/>
  </form>
</template>

<script>
export default {
  name: 'CForm',

  props: {
    requiredFields: {
      type: Boolean
    }
  }
}
</script>
